import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class GetPassengerByAreaCommand extends IRequestCommand<
  IGetPassengerByAreaResponse,
  ErrorDetails,
  IGetPassengerByAreaCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'contractorEmployees/byArea/{areaId}/paginated';

  public override setParameters(parameters: IGetPassengerByAreaCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{areaId}',
      parameters.areaId.toString()
    );
  }
}

export interface IGetPassengerByAreaCommandParameters {
  areaId: string;
}

export interface IGetPassengerByAreaResponse extends ICommandResponse {}
